function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _temp;

var _require = require('@uppy/core'),
    UIPlugin = _require.UIPlugin;
/* eslint-disable max-len */

/**
 * Add Redux DevTools support to Uppy
 *
 * See https://medium.com/@zalmoxis/redux-devtools-without-redux-or-how-to-have-a-predictable-state-with-any-architecture-61c5f5a7716f
 * and https://github.com/zalmoxisus/mobx-remotedev/blob/master/src/monitorActions.js
 */

/* eslint-enable max-len */


module.exports = (_temp = _class = /*#__PURE__*/function (_UIPlugin) {
  _inherits(ReduxDevTools, _UIPlugin);

  var _super = _createSuper(ReduxDevTools);

  function ReduxDevTools(uppy, opts) {
    var _this;

    _classCallCheck(this, ReduxDevTools);

    _this = _super.call(this, uppy, opts);
    _this.type = 'debugger';
    _this.id = _this.opts.id || 'ReduxDevTools';
    _this.title = 'Redux DevTools'; // set default options

    var defaultOptions = {}; // merge default options with the ones set by user

    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);
    _this.handleStateChange = _this.handleStateChange.bind(_assertThisInitialized(_this));
    _this.initDevTools = _this.initDevTools.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ReduxDevTools, [{
    key: "handleStateChange",
    value: function handleStateChange(prevState, nextState) {
      this.devTools.send('UPPY_STATE_UPDATE', nextState);
    }
  }, {
    key: "initDevTools",
    value: function initDevTools() {
      var _this2 = this;

      this.devTools = window.devToolsExtension.connect();
      this.devToolsUnsubscribe = this.devTools.subscribe(function (message) {
        if (message.type === 'DISPATCH') {
          // Implement monitors actions
          switch (message.payload.type) {
            case 'RESET':
              _this2.uppy.reset();

              return;

            case 'IMPORT_STATE':
              {
                var computedStates = message.payload.nextLiftedState.computedStates;
                _this2.uppy.store.state = _objectSpread(_objectSpread({}, _this2.uppy.getState()), computedStates[computedStates.length - 1].state);

                _this2.uppy.updateAll(_this2.uppy.getState());

                return;
              }

            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
              _this2.uppy.store.state = _objectSpread(_objectSpread({}, _this2.uppy.getState()), JSON.parse(message.state));

              _this2.uppy.updateAll(_this2.uppy.getState());

          }
        }
      });
    }
  }, {
    key: "install",
    value: function install() {
      // eslint-disable-next-line no-underscore-dangle
      this.withDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;

      if (this.withDevTools) {
        this.initDevTools();
        this.uppy.on('state-update', this.handleStateChange);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      if (this.withDevTools) {
        this.devToolsUnsubscribe();
        this.uppy.off('state-update', this.handleStateUpdate);
      }
    }
  }]);

  return ReduxDevTools;
}(UIPlugin), _class.VERSION = "2.0.3", _temp);